import { render, staticRenderFns } from "./subBranch.vue?vue&type=template&id=4e4c6039&scoped=true"
import script from "./subBranch.vue?vue&type=script&lang=js"
export * from "./subBranch.vue?vue&type=script&lang=js"
import style0 from "./subBranch.vue?vue&type=style&index=0&id=4e4c6039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c6039",
  null
  
)

export default component.exports